import React, { Dispatch, SetStateAction, useState, useEffect } from 'react';
import { IPriceInfo, IPromoCode } from 'pages/newSubscription/models';
import FormGeneralError from 'components/formComponents/FormGeneralError';
import { Package } from 'pages/newSubscription/models';
import { ThreeBounce } from 'better-react-spinkit';
import { useSelector } from 'react-redux';
import { selectSelectedPackages, selectValidPromoCode } from 'reducers/misc';
import { PricingSummaryDetailsApi } from './pricingSummaryDetailsApi';

type PricingSummaryDetailsProps = {
  addPromoStep: boolean;
  promoCode?: IPromoCode;
  setPromoCode?: Dispatch<SetStateAction<IPromoCode>>;
  vatRate?: number | null;
  applyPromoCode?: (vatRate: number) => Promise<void>;
  onContinue?: () => void;
  isDisabled?: any;
  isSubmitting?: any;
  btnText?: string;
};

export const PricingSummaryDetails: React.FC<PricingSummaryDetailsProps> = ({
  addPromoStep,
  promoCode,
  setPromoCode,
  vatRate,
  applyPromoCode,
  onContinue,
  isDisabled,
  isSubmitting,
  btnText
}) => {
  const [packageListIds, setPackageListIds] = useState<[]>([]);
  const [summaryData, setSummaryData] = useState<any>(null);

  const selectedPackagesList = useSelector(selectSelectedPackages);
  const validPromoCode = useSelector(selectValidPromoCode);

  useEffect(() => {
    let packageIdsList: any = [];

    selectedPackagesList.map((item: any) => {
      item.packageIDs.map((pi_item: number) => {
        packageIdsList.push(pi_item);

        return pi_item;
      });

      return item;
    });

    setPackageListIds(packageIdsList);
  }, [selectedPackagesList]); 



  useEffect(() => {
    loadSummaryData();
  }, [packageListIds, validPromoCode]); 
  
  const loadSummaryData = async () => {
    setSummaryData(null);

    const result = await PricingSummaryDetailsApi.getPricingSummaryDetails({
      promoCode: validPromoCode,
      packageIDs: packageListIds
    });

    if(!result.error){
      setSummaryData(result.data);
    }
  };

  return (
    <div className="PricingSummaryBlock">
      <h2>Summary</h2>

      {addPromoStep &&
        <div className="TotalDetails">
          <div className="DiscoundContainer">
            <input
              className="Discount"
              type="text"
              onChange={(e) =>
                setPromoCode && setPromoCode((prevState) => ({
                  ...prevState,
                  value: e.target.value,
                }))
              }
              value={promoCode && promoCode.value}
              placeholder="Enter promo code (optional)"
            />

            <button
              className="Btn BtnOrange"
              type="button"
              disabled={promoCode && promoCode.value && vatRate ? false : true}
              onClick={() => vatRate && applyPromoCode && applyPromoCode(vatRate)}
            >
              Apply
            </button>
          </div>
        </div>
      }

      {summaryData && summaryData.listSubjects && summaryData.listSubjects.length > 0 &&
        <div className="SummaryDetailsBlock">
          {summaryData.listSubjects.map((item: any, index: number) => {
            return (
              <div className="LessonRow" key={"Summary_Lesson_Row_" + index}>
                <div className="SubjectTxt">{item.name}</div>
                <div className="GroupYearTxt">{item.shortDescription}</div>
              </div>
            );
          })}
        </div>         
      }       

      <div className="TotalDetails">
        {summaryData ?
          <div className="DiscoundContainer">
            {summaryData.price > -1 &&
              <div className="DetailsItem">
                <p>Price</p>
                <span>£ {summaryData.price.toFixed(2)}</span>
              </div>            
            }
            {summaryData.discountType &&
              <>
                {summaryData.price > -1 && summaryData.discountedPrice > -1 &&
                  <div className="DetailsItem">
                    <p>Discount {summaryData.discountType && <>({summaryData.discountType})</>}</p>
                    <span>-£ {(summaryData.price - summaryData.discountedPrice).toFixed(2)}</span>
                  </div> 
                }
                {summaryData.discountedPrice &&
                  <div className="DetailsItem">
                    <p>Discounted price</p>
                    <span>£ {summaryData.discountedPrice.toFixed(2)}</span>
                  </div> 
                }                
              </>
            }
            {summaryData.vat > -1 &&
              <div className="DetailsItem">
                <p>VAT (%)</p>
                <span>£ {summaryData.vat.toFixed(2)}</span>
              </div> 
            }
            {summaryData.totalPrice > -1 &&
              <div className="DetailsItem">
                <p>Total</p>
                <span>£ {summaryData.totalPrice.toFixed(2)}</span>
              </div>              
            }                                                      
          </div>
        :
          <div className="DiscoundContainer">
            <div className="DetailsItem">
              <p>Price</p>
              <span>£ 0.00</span>
            </div>
            <div className="DetailsItem">
              <p>VAT</p>
              <span>£ 0.00</span>
            </div>
            <div className="DetailsItem">
              <p>Total</p>
              <span>£ 0.00</span>
            </div>                             
          </div>
        }

        {addPromoStep ? 
          <button
            className="Btn BtnOrange"
            type="submit"
            onClick={onContinue}
            disabled={(packageListIds && packageListIds.length === 0) || (summaryData?.price === 0)}
          >
            Continue
          </button>
          :
          <button
            className="Btn BtnOrange"
            type="submit"
            disabled={isDisabled}
          >
            {isSubmitting ? (
              <ThreeBounce size={10} color={'#ffffff'} />
            ) : (
              btnText
            )}
          </button>
        }           
      </div>
    </div>
  );
};